/**
 * Static dropdown options for the Sponsor Data filters. Everything shown in the
 * cards and the students grid comes from the sponsor data endpoints.
 */

const currentYear = new Date().getFullYear();

export const YEAR_OPTIONS = Array.from(
  { length: currentYear - 2020 + 1 },
  (_, i) => {
    const year = currentYear - i;
    return { id: year, name: year.toString() };
  }
);

export const GENDER_OPTIONS = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
  { id: "other", name: "Other" },
];
